import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  message: string = 'no-message';

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,   
    @Inject(MAT_DIALOG_DATA) public data?: string,
  ) {
  }

  ngOnInit() {
    this.message = this.data;
  }

}
